/*
 * Copyright (c) 2023 D2ArmorPicker by Mijago.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { Component } from "@angular/core";

import { ConfigurationService } from "../../../../services/configuration.service";

@Component({
  selector: "app-desired-mod-selection",
  templateUrl: "./desired-mod-limit-selection.component.html",
  styleUrls: ["./desired-mod-limit-selection.component.scss"],
})
export class DesiredModLimitSelectionComponent {
  constructor(public config: ConfigurationService) {}

  // New clear for statModLimits
  clear() {
    this.config.modifyConfiguration((c) => {
      c.statModLimits = { maxMods: 5, maxMajorMods: 5 };
      c.armorRequirements = [];
    });
  }
}
